import script from "./1.HadFacial.vue?vue&type=script&setup=true&lang=ts"
export * from "./1.HadFacial.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__